module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    style: ({
      backgroundColor: _vm.statusBgColor
    }),
    on: {
      "click": _vm.makeLink
    }
  }, [(_vm.isForecastManager || _vm.isZonesSupervisor) ? _c('td', {
    staticClass: "check",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('CheckboxTable', {
    attrs: {
      "value": _vm.isSelected(),
      "forecastId": _vm.forecast.id
    },
    on: {
      "updateValue": _vm.addSelect
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "id px-2"
  }, [_c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.forecast.id) + " ")])])]), _vm._v(" "), _c('td', {
    staticClass: "ref pl-2 pr-4"
  }, [_vm._v(_vm._s(_vm.forecast.reference))]), _vm._v(" "), _c('td', {
    staticClass: "name px-2"
  }, [_vm._v(_vm._s(_vm.forecast.name))]), _vm._v(" "), _c('td', {
    staticClass: "calendar px-2"
  }, [_c('DateInfosSimple', {
    attrs: {
      "forecast": _vm.forecast,
      "forecast-window": _vm.window
    }
  })], 1), _vm._v(" "), (_vm.window == null) ? _c('td', {
    staticClass: "markets px-2"
  }, [_vm._v(_vm._s(_vm.marketsSubmitted))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "items px-2"
  }, [_vm._v(_vm._s(_vm.items))]), _vm._v(" "), _c('td', {
    staticClass: "approved px-2"
  }, [(_vm.isApproved) ? [_c('ApprovedIcon')] : _vm._e()], 2), _vm._v(" "), (_vm.window == null || _vm.displayXlsExport) ? _c('td', {
    staticClass: "xls px-2",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.isXlsExist) ? [_c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    on: {
      "click": function($event) {
        _vm.exportXls(_vm.forecast)
      }
    }
  }, [_c('XlsExportIcon', {
    attrs: {
      "color": _vm.statusColor
    }
  })], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "status px-2",
    style: ({
      backgroundColor: _vm.statusColor
    })
  }, [_vm._v(_vm._s(_vm.statusName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0801457f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ForecastDetailBanner.vue
// module id = 2996
// module chunks = 0